(function () {
  class AiReviewsAsymmetric extends HTMLElement {
    constructor() {
      super();
      this.isTouchDevice =
        "ontouchstart" in window || navigator.maxTouchPoints > 0;

      this.resizeObserver = null;
      this.syncGridHeight = this.syncGridHeight.bind(this);
      this.desktopQuery = window.matchMedia("(min-width: 990px)");
    }

    connectedCallback() {
      if (this.isTouchDevice) {
        this.setupTouchInteractions();
      }

      if (this.desktopQuery.matches) { this.setupHeightSync(); }
    }

    disconnectedCallback() {
      // Cleanup observer (important for Shopify section reloads)
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    /* HEIGHT SYNC */
    setupHeightSync() {
      this.firstItem = this.querySelector(
        ".reviews-asymmetric-item:not(.reviews-asymmetric-item-wide)"
      );

      this.secondGrid = this.querySelector(
        ".reviews-asymmetric-grid.below"
      );

      if (!this.firstItem || !this.secondGrid) return;

      // Initial sync
      this.syncGridHeight();

      // Track element size changes (better than window resize)
      this.resizeObserver = new ResizeObserver(this.syncGridHeight);
      this.resizeObserver.observe(this.firstItem);
    }

    syncGridHeight() {
      if (!this.firstItem || !this.secondGrid) return;

      const height = this.firstItem.getBoundingClientRect().height;
      this.secondGrid.style.height = `${height}px`;
    }

    /* TOUCH INTERACTIONS */

    setupTouchInteractions() {
      const reviewItems = this.querySelectorAll(
        ".reviews-asymmetric-item, .reviews-asymmetric-item-wide"
      );

      reviewItems.forEach((item) => {
        const overlay = item.querySelector(".reviews-asymmetric-overlay");

        if (overlay && overlay.classList.contains("hover-overlay")) {
          item.addEventListener("click", (e) => {
            e.stopPropagation();
            const isActive = item.classList.contains("active");

            reviewItems.forEach((otherItem) => {
              if (otherItem !== item) {
                otherItem.classList.remove("active");
              }
            });

            item.classList.toggle("active", !isActive);
          });
        }
      });

      document.addEventListener("click", (e) => {
        if (
          !e.target.closest(".reviews-asymmetric-item") &&
          !e.target.closest(".reviews-asymmetric-item-wide")
        ) {
          reviewItems.forEach((item) => item.classList.remove("active"));
        }
      });
    }
  }

  customElements.define("reviews-asymmetric", AiReviewsAsymmetric);
})();